import ReactDiffViewer from 'react-diff-viewer-continued';
import styled from 'styled-components';
import { MODAL_SIZES, Modal, ModalBody, ModalHeader } from 'ui/modal';
import { fontSizes, spacing } from 'ui/theme';
import { useModalContext } from 'utils/contexts/modal';

import { useWYSIWYGContext } from '../../contexts/WYSIWYGContext';
import { useTranslations } from '../../hooks/useTranslations';

const StyledModalBody = styled(ModalBody)`
  flex: 1 1 auto;
  padding: 0 ${spacing.plusHalf} ${spacing.plusHalf};
`;

const StyledModalSubheader = styled(ModalBody)`
  border: none;
  flex: 0 0 auto;
  font-size: ${fontSizes.s14};
  padding: 0 ${spacing.plusHalf} ${spacing.plusHalf};
`;

export const HtmlDiffViewerModal = () => {
  const { t } = useTranslations();
  const { contentValue: newCode, lastSavedValue: oldCode } = useWYSIWYGContext();
  const { hideModal } = useModalContext();

  return (
    <Modal
      id="wysiwygHtmlDiffViewerModal"
      isModalOpen={true}
      onClose={hideModal}
      size={MODAL_SIZES.LARGE}
    >
      <ModalHeader autoFocus={false}>{t('header.diffViewer')}</ModalHeader>
      <StyledModalSubheader>{t('caption.diffViewerSubheader')}</StyledModalSubheader>
      <StyledModalBody>
        <ReactDiffViewer
          leftTitle={t('label.oldCode')}
          newValue={newCode}
          oldValue={oldCode}
          rightTitle={t('label.newCode')}
          splitView={true}
          styles={{
            contentText: { wordWrap: `unset` }, // break long lines as necessary
            // @ts-ignore
            lineNumber: { whiteSpace: `nowrap !important` }, // prevent line numbers from wrapping
          }}
          useDarkTheme={true}
        />
      </StyledModalBody>
    </Modal>
  );
};
